// extracted by mini-css-extract-plugin
module.exports = {"subtitleContainer":"headersubtitle_subtitleContainer__144uW"};